import {isEmpty, map} from "lodash";
import CampaignRow from "components/campaign/row/CampaignRow";
import styles from "./StoresHeader.module.scss";
import Image from "grandus-lib/components-atomic/image/Image";
import Link from "next/link";
import {useEffect, useState} from "react";
import {ArrowDownOutlined, ArrowUpOutlined} from "@ant-design/icons";

const CampaignsHeadline = ({ title = null, isContentVisible = false, toggleCallback }) => (
    <>
        <h1 className="d-none d-lg-block">{title ?? 'Mohlo by Vás zaujímať'}</h1>
        <a className="d-flex justify-content-between align-items-center d-lg-none" onClick={toggleCallback}>
            <h1>{title ?? 'Mohlo by Vás zaujímať'}</h1>
            {isContentVisible ? <ArrowUpOutlined className={styles.icon} /> : <ArrowDownOutlined className={styles.icon} /> }
        </a>
    </>
);

const CampaignsList = ({ campaigns, campaignsTitle }) => {
    const [ isOpen, setIsOpen ] = useState(true);

    useEffect(() => {
        setIsOpen(window.innerWidth > 990);
    }, []);

    const toggleCampaigns = () => {
        setIsOpen(!isOpen);
    }

    if (isEmpty(campaigns)) {
        return null;
    }

    return (
        <div className={`col-12 col-lg-5 ${styles.campaigns}`}>
            <CampaignsHeadline title={campaignsTitle?.perex} isContentVisible={isOpen} toggleCallback={toggleCampaigns} />
            <div className={`${isOpen ? 'd-flex' : 'd-none d-lg-flex'} flex-column`}>
                {map(campaigns, (campaign, index) => {
                        if (index > 4) {
                            return ""
                        }
                        return (
                            <CampaignRow
                                {...campaign}
                                key={`campaigns-${campaign?.id}`}
                            />
                        )
                    }
                )}
                <Link href="/akcie">
                    <a className={`button ${styles.showAllCampaigns}`}>Zobraziť všetky akcie</a>
                </Link>
            </div>
        </div>
    );
}

const StoresHeader = ({ campaigns, campaignsTitle, storesMap }) => {
    return (
        <section id={styles.storeHeader} className="container">
            <div className="row">
                <CampaignsList campaignsTitle={campaignsTitle} campaigns={campaigns} />
                {storesMap ? (
                    <div className={`col-12 col-lg-7 ${styles.map}`}>
                        <h1>{storesMap.perex}</h1>
                        <div className={styles.mapBg}>
                            <Image
                                photo={storesMap.photo}
                                size={"760x373"}
                                type={"png"}
                                useNextImage={true}
                                priority={true}
                            />
                        </div>
                    </div>
                ) : null}
            </div>

            {storesMap?.content ? (
                <div className={`${styles.description} row`}>
                    <div className="col-12" dangerouslySetInnerHTML={{__html: storesMap.content}}></div>
                </div>
            ) : null}
        </section>
    )
}

export default StoresHeader;
